import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";

import ListDetailCard from "../../Components/Card/ListDetailCard";
import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { getPodcastList } from "./Services";
import { getFormatedDate } from "../../Js/TimeAndDate";
import TopButton from "../../Components/UI/TopButtons";
import {
  getRolesBySiteUuid,
  getUsersByRoleId,
} from "../../Layouts/Users/Services";
import { joinByKeys } from "../../Js/Common";
import Confirmation from "../../Components/Modal/Confirmation";
import PodcastDetailCard from "../../Components/Card/PodcastDetailCard";

const PodcastList = (props) => {
  // Hooks
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const listInnerRef = useRef();

  const paginationVal = 15;

  // State
  const [podcast, setPodcast] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [skipData, setSkipData] = useState(0);
  const [limitData, setLimitData] = useState(paginationVal);
  const [totalData, setTotalData] = useState(0);
  const [trainers, setTrainers] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [clickedUid, setClickedUid] = useState(null);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  const initialRender = useCallback(async () => {
    let trainerUuids = [];
    let resTrainer = await getTrainerRole();
    if (resTrainer) {
      let params = {
        query: {
          $select: ["uid", "name"],
          role_uid: resTrainer.uid,
          site_uuid: userInfo.site_uuid,
          status: true,
          $limit: -1,
        },
      };
      let resUsersData = await getUsersByRoleId(params);
      // console.log("resUsersData===>", resUsersData);
      if (resUsersData.data.length > 0) {
        let trainerUuids = resUsersData.data.map((userData) => {
          delete userData.rolesInfo;
          let newUserData = {};
          newUserData.name = joinByKeys(
            userData.name,
            ["firstname", "lastname"],
            " "
          );
          newUserData.value = userData.uid;
          return newUserData;
        });
        console.log("trainerUuids", trainerUuids);
        setTrainers(trainerUuids);
      }
    }
  }, [userInfo]);

  const getTrainerRole = async () => {
    let params = {
      query: {
        $select: ["uid", "title"],
        title: "Trainer",
        site_uuid: userInfo.site_uuid,
      },
    };
    let resRolesData = await getRolesBySiteUuid(params);
    return resRolesData.data[0];
  };

  // React logic hooks
  useEffect(() => {
    dispatch(commonSliceActions.setLoader(true));
    initialRender();
    fetchPodcast(props.filter);
    //dispatch(assignmentSliceActions.resetState());
  }, [props.filter]);

  useEffect(() => {
    const paginationRender = async () => {
      dispatch(commonSliceActions.setLoader(true));
      await fetchPodcast();
    };
    if (isFetching) {
      paginationRender();
    }
  }, [isFetching]);

  const handleFilter = async (params) => {
    setSkipData(0);
    setLimitData(paginationVal);

    let query = {};

    if (params.assignmentName) {
      query.context = {
        title: {
          $iLike: `%${params.assignmentName}%`,
        },
      };
    }

    if (params.start_date && params.end_date) {
      query.createdAt = {
        $gt: params.start_date,
        $lt: params.end_date,
      };
    }

    let resPodcastData = await getPodcastList(
      userInfo.uid,
      userInfo.site_uuid,
      0,
      paginationVal,
      props.filter,
      query
    );

    console.log("resAssignmentData", resPodcastData);
    setTotalData(resPodcastData.data.total);
    setPodcast(resPodcastData.data.data);
  };

  // Fetch Assignment Data
  const fetchPodcast = async (filterType) => {
    let podcastData = await getPodcastList(
      userInfo.uid,
      userInfo.site_uuid,
      skipData,
      limitData,
      filterType
    );
    console.log("podcastData", podcastData);

    setIsFetching(false);
    setIsLoading(false);
    dispatch(commonSliceActions.setLoader(false));
    if (skipData == 0) {
      setTotalData(podcastData.data.total);
      props.setTotalNumber(podcastData.data.total);
      setPodcast(podcastData.data.data);
      props.setPodcastNumber(podcastData.data.data.length);
    } else {
      let newData = [...podcast, ...podcastData.data.data];
      props.setPodcastNumber(newData.length);
      setPodcast(newData);
    }
  };

  // Route redirect function
  const goTo = (id) => {
    navigation(`/Podcast/Info/${id}`);
  };

  const handleInfinityScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      let totalHeight = Math.ceil(scrollTop + clientHeight);
      if (
        totalHeight >= scrollHeight ||
        totalHeight == scrollHeight - 1 ||
        totalHeight === scrollHeight
      ) {
        return true;
      }
      return false;
    }
  };

  const handleLoadMore = () => {
    if (podcast && +podcast.length < +totalData) {
      setIsLoading(true);
    }
    setTimeout(() => {
      if (skipData / paginationVal < Math.ceil(totalData / paginationVal) - 1) {
        let totSkipData = skipData + limitData;
        console.log("totSkipData", totSkipData);
        setSkipData(() => totSkipData);
        setLimitData(() => limitData);
        setIsFetching(() => true);
      }
    }, 1000);
  };

  const getTrainerName = (uid) => {
    let foundObj = trainers.find((o) => o.value == uid);
    return foundObj.name;
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <TopButton
          title={podcast ? `${podcast.length}/${totalData}` : ``}
          centerText={isLoading ? "Loading..." : ""}
          searchLabel={"Podcast Title:"}
          isReportFilter={true}
          handleFilter={(params) => {
            handleFilter(params);
          }}
          classesHide={true}
        />
      </Grid>
      <Grid
        item
        xs={12}
         
        ref={listInnerRef}
        sx={{
          height: "67vh",
          overflow: isLoading ? "hidden" : "auto",
          mt: 1,
          backgroundImage: `url(/podcastbg.png)`,
          backgroundSize: "100%",
          backgroundRepeat: "no-repeat",
        }}
        onScroll={() => {
          if (handleInfinityScroll()) {
            handleLoadMore();
          }
        }}
      >
        <Grid>
          <Grid item xs={12}>
            <Grid
              container
              sx={{
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "flex-start",
              }}
            >
              {podcast &&
                podcast.length > 0 &&
                trainers.length > 0 &&
                podcast.map((obj, index) => {
                  return (
                    <div key={`${index}_task`}>
                      <PodcastDetailCard
                        title={obj.context.title}
                        subtitle={"Learners: " + obj.context.user_uuid.length}
                        primary={getTrainerName(obj.approval_by)}
                        secondary={
                          "Created On: " + getFormatedDate(obj.createdAt)
                        }
                        filter={props.filter}
                        press={() => {
                          if (
                            !(
                              props.filter == "approvalPending" ||
                              props.filter == "approved"
                            )
                          ) {
                            setClickedUid(obj.uid);
                            if (props.filter == "new") {
                              setConfirmModal(true);
                            } else {
                              navigation(`/Podcast/RecordingEdit/${obj.uid}`);
                            }
                          }
                        }}
                      ></PodcastDetailCard>
                    </div>
                  );
                })}
            </Grid>
          </Grid>
        </Grid>
        <Confirmation
          image="assign"
          primaryText="Podcast start / Information"
          secondaryText="Do you want to start your podcast now?"
          visible={confirmModal}
          positiveText={"Start Podcast"}
          negativeText={"Information"}
          positiveClick={() => {
            setConfirmModal(false);
            navigation(`/Podcast/Recording/${clickedUid}`);
          }}
          negativeClick={() => {
            setConfirmModal(false);
            goTo(clickedUid);
          }}
          toggleModal={(flag) => setConfirmModal(flag)}
        ></Confirmation>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default PodcastList;
